import axios from 'axios';
import {URL} from '../services/urls';

const api = axios.create({
    baseURL: URL
});

// Interceptor para añadir token a todas las peticiones
api.interceptors.request.use(
    (config) => {
        const user = JSON.parse(localStorage.getItem('loggedNewIntranetAppUser') || '{}');
        if (user.accesToken) {
            config.headers.Authorization = `Bearer ${user.accesToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor de respuesta para redirigir al login si la sesión expira
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('loggedNewIntranetAppUser');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;

export const apiIntranet = axios.create({
    baseURL: URL
});
